<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Create New SMS Template</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="smsTemplatesForm">
                <b-row>
                    <!-- FIELD STATUS -->
                    <b-col cols="12">
                        <b-form-group label="Title:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'title'"
                            >
                            <b-form-input
                                v-model="form.sms_title"
                                type="text"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD STATUS TYPE -->
                    <b-col cols="12">
                        <b-form-group label="Content:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, maxChars: true }"
                                :vid="'content'"
                            >
                            <b-form-textarea
                                v-model="form.sms_content"
                                placeholder="Enter sms content..."
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                <small v-if="!errors[0]" class="text-muted">{{ charCount }} characters | {{ smsCount }} SMS</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Customer Sub Status:">
                            <el-select
                                v-model="form.customer_status_id"
                                value-key="status_id"
                                filterable
                                >
                                <el-option :label="'-- Please select sub status --'" :value="null"></el-option>
                                <el-option
                                v-for="status in customerSubStatusList"
                                :key="status.status_id"
                                :label="status.parent_status + ' - ' + status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Create</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Checkbox } from 'element-ui'
import { 
    notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { extend } from 'vee-validate';

export default {
    props:{
        create_new_sms_templates: Boolean,
        customerSubStatusList: Array
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    created(){
        extend('maxChars', {
            validate: () => this.charCount <= 155,
            message: 'SMS Content should not exceed 155 characters',
        });
    },
    computed: {
        show: {
            get() {
                return this.create_new_sms_templates;
            },
            set(newVal) {
                this.$emit('update:create_new_sms_templates', newVal);
            },
        },
        charCount() {
            return this.form.sms_content.length;
        },
        smsCount() {
            return Math.ceil(this.charCount / 160);
        },
    },
    data() {
        return {
            form: {
                sms_title: '',
                sms_content: '',
                customer_status_id: null,
            },
        }
    },
    methods:{
        submit(){
            let form = new FormData()
            form.append('sms_title',this.form.sms_title)
            form.append('sms_content',this.form.sms_content)
            form.append('customer_status_id',this.form.customer_status_id)
            axios.post(services.messaging + 'sms-template', form, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>SMS Template</b> - Successfully Created.')
                this.$emit('closeModal', false)
                mainEventBus.$emit('refresh-status')
                this.resetFormToNull(this.form)
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
     }
}
</script>